import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c2a2e58c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.less?vue&type=style&index=0&id=c2a2e58c&prod&lang=less&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=c2a2e58c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a2e58c",
  null
  
)

export default component.exports